/**
 * Klaviyo Back in Stock Integration
 * 
 * Offizielle Klaviyo Back in Stock-Integration gemäß der Dokumentation.
 * Angepasst für das Glowcane-Theme mit deutschen Texten und angepasstem Design.
 * Verwendet Shopify-eigene Schriftarten anstelle von Google Fonts.
 */

// Klaviyo Back in Stock Integration
var klaviyo = klaviyo || [];
klaviyo.init({
  account: "SRJbBL",
  platform: "shopify"
});

// Backinstock-Funktionalität aktivieren mit angepassten Parametern
klaviyo.enable("backinstock", { 
  trigger: {
    product_page_text: "💌 Benachrichtigen wenn verfügbar",
    product_page_class: "button button--primary button--full-width",
    product_page_text_align: "center",
    product_page_margin: "0px",
    replace_anchor: false,
    custom_trigger_selector: ".klaviyo-bis-trigger"
  },
  modal: {
    headline: "{product_name}",
    body_content: "Registriere dich, um benachrichtigt zu werden, wenn dieser Artikel wieder auf Lager ist.",
    email_field_label: "E-Mail",
    button_label: "💌 Benachrichtigen wenn verfügbar",
    subscription_success_label: "Juhu! 🎉 Wir schicken dir eine Nachricht, sobald dein Lieblingsprodukt wieder da ist!",
    footer_content: '',
    additional_styles: "", // Google Fonts entfernt - verwendet jetzt Shopify Theme Fonts
    drop_background_color: "#000",
    background_color: "#fff",
    text_color: "#222",
    button_text_color: "#fff",
    button_background_color: "#000",
    close_button_color: "#ccc",
    error_background_color: "#fcd6d7",
    error_text_color: "#C72E2F",
    success_background_color: "#d3efcd",
    success_text_color: "#1B9500",
    font_family: "var(--font-body-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif)" // Shopify Theme Font oder System Font
  }
});

// Lokale Testumgebung für Entwicklung
(function() {
  // Warten, bis das DOM vollständig geladen ist
  document.addEventListener('DOMContentLoaded', function() {
    console.log('Klaviyo BIS: DOM geladen, initialisiere...');
    
    // Prüfen, ob wir in einer lokalen Testumgebung sind
    const isLocalEnvironment = window.location.hostname === 'localhost' || 
                              window.location.hostname === '127.0.0.1' ||
                              window.location.hostname.includes('.myshopify.com');
    
    if (isLocalEnvironment) {
      // Finden aller Klaviyo BIS Trigger-Buttons
      const bisButtons = document.querySelectorAll('.klaviyo-bis-trigger');
      
      if (bisButtons.length === 0) {
        console.log('Klaviyo BIS: Keine Buttons gefunden');
        return;
      }
      
      console.log('Klaviyo BIS: ' + bisButtons.length + ' Button(s) gefunden');
      
      // Event-Listener für jeden Button hinzufügen
      bisButtons.forEach(function(button) {
        console.log('Klaviyo BIS: Event-Listener hinzugefügt für Button', button);
        
        button.addEventListener('click', function(event) {
          event.preventDefault();
          console.log('Klaviyo BIS: Button wurde geklickt');
          
          // Produkt- und Varianten-ID aus den Datenattributen abrufen
          const productId = button.getAttribute('data-product-id');
          const variantId = button.getAttribute('data-variant-id');
          
          console.log('Klaviyo BIS: Produkt-ID:', productId);
          console.log('Klaviyo BIS: Varianten-ID:', variantId);
          
          // Zeige lokales Testformular
          showLocalTestForm(productId, variantId);
        });
      });
    }
  });
  
  /**
   * Zeigt ein einfaches Formular für die lokale Testumgebung an
   */
  function showLocalTestForm(productId, variantId) {
    // Produktnamen aus der Seite abrufen
    const productName = document.querySelector('.product__title h1')?.textContent.trim() || 'Produkt';
    
    // Erstelle ein einfaches Formular
    const formHtml = `
      <div id="klaviyo-bis-local-form" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.7); display: flex; justify-content: center; align-items: center; z-index: 9999;">
        <div style="background: white; padding: 20px; border-radius: 5px; max-width: 500px; width: 90%; font-family: var(--font-body-family, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif);">
          <h2 style="margin-top: 0;">${productName}</h2>
          <p>Registriere dich, um benachrichtigt zu werden, wenn dieser Artikel wieder auf Lager ist.</p>
          <div style="margin-bottom: 15px;">
            <label for="klaviyo-bis-email" style="display: block; margin-bottom: 5px;">E-Mail</label>
            <input type="email" id="klaviyo-bis-email" style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;" placeholder="Deine E-Mail-Adresse">
          </div>
          <div style="display: flex; justify-content: space-between;">
            <button id="klaviyo-bis-submit" style="background: #000; color: white; border: none; padding: 10px 15px; border-radius: 4px; cursor: pointer;">💌 Benachrichtigen wenn verfügbar</button>
            <button id="klaviyo-bis-close" style="background: #ccc; color: black; border: none; padding: 10px 15px; border-radius: 4px; cursor: pointer;">Schließen</button>
          </div>
          <div style="display: none;">
            <p><small>Produkt-ID: ${productId}, Varianten-ID: ${variantId}</small></p>
          </div>
        </div>
      </div>
    `;
    
    // Füge das Formular zum DOM hinzu
    const formContainer = document.createElement('div');
    formContainer.innerHTML = formHtml;
    document.body.appendChild(formContainer);
    
    // Event-Listener für das Formular
    document.getElementById('klaviyo-bis-submit').addEventListener('click', function() {
      const email = document.getElementById('klaviyo-bis-email').value;
      if (email) {
        alert('Juhu! 🎉 Wir schicken dir eine Nachricht, sobald dein Lieblingsprodukt wieder da ist! Danke für deine Geduld.');
        document.getElementById('klaviyo-bis-local-form').remove();
      } else {
        alert('Bitte gib deine E-Mail-Adresse ein, damit wir dich benachrichtigen können!');
      }
    });
    
    document.getElementById('klaviyo-bis-close').addEventListener('click', function() {
      document.getElementById('klaviyo-bis-local-form').remove();
    });
  }
})();